<template>
    <Card>
        <template v-slot:icon>
            <i class="fas fa-upload"/>
        </template>
        <template v-slot:title>
            Submit inventory file
        </template>
        <template v-slot:description>
            Select the file you want to submit.
        </template>

        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="font-weight-bold">Select target store</label>
                    <StoreSelect :stores="stores" @input="store => form.store_uuid = store.id"/>
                    <span class="form-text text-muted">Select the store the stock items should be uploaded for.</span>
                    <FormErrors :error="form.errors.store_uuid"/>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="font-weight-bold">Select inventory feed</label>
<!--            <div class="mb-1">-->
<!--                <div class="btn-group">-->
<!--                    <button class="btn btn-sm px-10"-->
<!--                            :class="{-->
<!--                        'btn-primary': isFileUpload,-->
<!--                        'btn-outline-secondary': !isFileUpload-->
<!--                    }"-->
<!--                            @click="isFileUpload = true"-->
<!--                    >-->
<!--                        <i class="fas fa-upload"/>-->
<!--                        File Upload-->
<!--                    </button>-->
<!--                    <button class="btn btn-sm px-10"-->
<!--                            :class="{-->
<!--                        'btn-primary': !isFileUpload,-->
<!--                        'btn-outline-secondary': isFileUpload,-->
<!--                            }"-->
<!--                            @click="isFileUpload = false"-->
<!--                    >-->
<!--                        <i class="fas fa-cloud"/>-->
<!--                        FTP Server-->
<!--                    </button>-->
<!--                </div>-->
<!--            </div>-->
            <FileSelect v-if="isFileUpload"
                        :file-types="acceptedFileTypes"
                        :max-files="1"
                        :value="[form.file]"
                        @input="updateFile"
            />
<!--            <div v-else>-->
<!--                ftp stuff-->
<!--            </div>-->
            <span class="form-text text-muted">
                Choose the file containing the stock items to upload. Supported file types: {{
                    acceptedFileTypes.join(', ')
                }}.
            </span>
            <FormErrors :error="form.errors.file"/>
        </div>
        <Transition>
            <div v-show="isCharacterSeparatedFormat" class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="font-weight-bold">Specify the delimiter</label>
                        <input class="form-control" type="text" placeholder="; for example" v-model="form.delimiter">
                        <span class="form-text text-muted">
                            Enter the character which marks the boundary of a column in the CSV file.
                        </span>
                        <FormErrors :error="form.errors.delimiter"/>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="font-weight-bold">Specify the enclosure character</label>
                        <input class="form-control" type="text" placeholder='" for example' v-model="form.enclosure">
                        <span class="form-text text-muted">
                                If the strings in the file are enclosed in a character, specify it here.
                        </span>
                        <FormErrors :error="form.errors.enclosure"/>
                    </div>
                </div>
            </div>
        </Transition>

        <template v-slot:footer>
            <button class="btn btn-primary"
                    :disabled="!allRequiredFieldsAreSet"
                    @click="submit"
            >
                <i class="fas fa-arrow-circle-right"/>
                Map columns
            </button>
        </template>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import FormErrors from "@components/Form/FormErrors.vue";
import StoreSelect from "@components/Store/StoreSelect.vue";
import FileSelect from "@components/Form/FileSelect.vue";
import FileSelectDropzone from "@components/Form/FileSelectDropzone.vue";

export default {
    components: {FileSelect, StoreSelect, FormErrors, Card, FileSelectDropzone},

    props: {
        stores: Array,
        mapping: Object | Array
    },

    data() {
        return {
            isFileUpload: true,
            acceptedFileTypes: ['xlsx', 'xls', 'ods', 'csv', 'tsv'],
            form: this.$inertia.form({
                store_uuid: null,
                file: null,
                delimiter: null,
                enclosure: null
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.$route('stocks.upload').url());
        },

        updateFile(files) {
            this.form.file = (files.length > 0 ? files[0] : null)
        }
    },

    computed: {
        allRequiredFieldsAreSet() {
            if (this.isCharacterSeparatedFormat) {
                if (this.form.delimiter == null || this.form.delimiter.length === 0) {
                    return false;
                }
            }

            return this.isValidFileType && this.form.store_uuid != null
        },

        isCharacterSeparatedFormat() {
            if (this.form.file === null) {
                return false;
            }

            return ['csv'].includes(Mime.extension(this.form.file.type))
        },

        isValidFileType() {
            if (this.form.file === null) {
                return false;
            }

            return this.acceptedFileTypes.includes(Mime.extension(this.form.file.type))
        },
    }
}
</script>

<style>
.v-enter-active,
.v-leave-active {
    transition: 0.32s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
    transform: translateY(-32px);
}
</style>
